/* WhatsAppFAB — floating action button rendered on public + customer
 * pages. Routes to Team Mera Naksha's central number with a contextual
 * pre-filled message. Auto-hidden on auth screens / admin / 403 pages.
 */
import React from "react";
import { useLocation } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { trackEvent } from "@/utils/analytics";

const HIDDEN_PREFIXES = ["/admin", "/customer/login", "/professional/login", "/login", "/403"];

const WhatsAppFAB = () => {
  const location = useLocation();
  if (HIDDEN_PREFIXES.some((p) => location.pathname === p || location.pathname.startsWith(p + "/"))) {
    return null;
  }
  // /admin/login is a special case — admins don't need a customer-support CTA
  if (location.pathname === "/admin/login") return null;

  const msg = encodeURIComponent("Hi Team Mera Naksha, I need help with my purchase.");
  return (
    <a
      href={`https://wa.me/919717667115?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp"
      onClick={() =>
        trackEvent("whatsapp_click", {
          page_section: "floating-fab",
          path: location.pathname,
        })
      }
      className="fixed bottom-5 right-5 z-40 inline-flex items-center gap-2 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white pl-3 pr-4 py-2.5 shadow-[0_12px_28px_-12px_rgba(16,185,129,0.55)] border border-emerald-700/40 backdrop-blur-sm transition-transform hover:scale-[1.03]"
    >
      <span className="h-7 w-7 rounded-full bg-white/15 grid place-items-center">
        <FaWhatsapp className="h-4 w-4" />
      </span>
      <span className="hidden sm:inline text-[13px] font-extrabold tracking-tight">
        Chat support
      </span>
    </a>
  );
};

export default WhatsAppFAB;
